import React from "react";

import { Grid, Box, Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { TextButton, Slider } from "../../../../components/base";

const useStyles = makeStyles((theme) => ({
  box: {
    borderBottom: `1px solid ${COLORS.darks[0][25]}`,
    padding: `${theme.spacing(4)}px ${theme.spacing(2.5)}px ${theme.spacing(4)}px ${theme.spacing(
      3.5
    )}px`,
  },
  header: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    marginLeft: theme.spacing(1.875),
  },
  sliderBox: {
    "&:not(.open)": {
      maxHeight: 0,
      overflow: "hidden",
      transition: "all .5s ease",
    },
    "&.open": {
      maxHeight: "400px",
      overflow: "hidden",
      transition: "all .5s ease",
    },
  },
  sliderRow: {
    marginTop: theme.spacing(2.25),
    "&:last-child": {
      paddingBottom: theme.spacing(1.25),
    },
  },
}));

export const Parameters = ({ data, setData, isSliderTriggered, setSliderTrigger }) => {
  const classes = useStyles();

  const handleClick = (i) => {
    const tempData = [...data];
    tempData[i].isOpen = !tempData[i].isOpen;
    setData(tempData);
  };

  const revert = (i) => {
    let tempData = [...data];
    const revertData = tempData.map((slider, index) => {
      if (index !== i) return slider;
      return {
        ...slider,
        sliders: slider.sliders.map((val) => {
          return { ...val, value: val.defaultValue };
        }),
      };
    });

    setData(revertData);
    setSliderTrigger(true);
  };

  const handleChange = (i, j, value) => {
    if (!isSliderTriggered) setSliderTrigger(true);
    let tempData = [...data];
    tempData[i].sliders[j].value = value;
    setData(tempData);
  };

  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} className={classes.box}>
          <Box className={classes.header} style={{ justifyContent: "space-between" }}>
            <Box
              className={classes.header}
              style={{ cursor: "pointer" }}
              onClick={() => handleClick(i)}
            >
              <Typography color="primary" variant="h4" style={{ width: 11 }}>
                {item.isOpen ? "-" : "+"}
              </Typography>
              <Typography variant="h4" className={classes.title}>
                {item.title}
              </Typography>
            </Box>
            {item.isOpen ? (
              <TextButton
                text="Revert"
                textStyle={{ fontWeight: 400, fontSize: 12 }}
                onClick={() => revert(i)}
              />
            ) : null}
          </Box>
          <Box className={`${classes.sliderBox} ${item.isOpen ? "open" : ""}`}>
            {item.sliders.map((slider, j) => (
              <Grid container key={j} alignItems="center" spacing={2} className={classes.sliderRow}>
                <Grid item xs={5}>
                  <Typography style={{ fontSize: 13 }}>{slider.label}</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Slider
                    color={COLORS.viking}
                    value={slider.value}
                    defaultValue={slider.defaultValue}
                    unit={slider.unit}
                    onChange={(_, value) => handleChange(i, j, value)}
                  />
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
